<template>
  <div class="container">
    <div v-html="content"></div>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  data() {
    return {
      content: ''
    }
  },
  async mounted() {
    const query = qs.parse(location.search.replace('?', ''))
    let contentType = query.ct
    // 临时兼容口算协议参数写错问题，后续口算版本（1.9.1）热更新/下架后可以删除该代码
    if (contentType === 'policyConfig') {
      contentType = 'privacyPolicy'
    }
    let res = await this.$deliverer.fetchSingleAdContent(contentType, {
      appKey: query.ak || '',
      isAuditMode: this.auditConversion(query.am),
      'tm-useragent-productversion': query.v || '',
      'tm-useragent-deviceos': query.p || '',
      'tm-useragent-appchannel': query.c || ''
    })
    this.content = res.data.configValue.content
    document.title = res.data.configValue.title
  },
  methods: {
    auditConversion(audit) {
      if (!audit) return ''
      if (audit === '1' || audit === 1) {
        return 'true'
      } else {
        return 'false'
      }
    }
  }
}
</script>

<style lang="scss" >
.container {
  padding: 10px 20px;
  table.ne-table {
    word-break: break-all;
    width: auto !important;

    td {
      border: 1px solid #d9d9d9;
      padding: 5px;
    }
  }
}
</style>
